<template>
  <div>
    <div class="container-fluid footer py-5 my-3 mb-0 bg-light wow bounceInUp" data-wow-delay="0.1s">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="footer-item">
                            <h1 class="text-primary"><span class="text-dark" v-html="$t('khaing_parami')"></span></h1>
                            <p class="lh-lg mb-4">{{ $t('khaing_parami_info') }}</p>
                            <div class="footer-icon d-flex">
                                <a class="btn btn-primary btn-sm-square me-2 rounded-circle" href="https://www.facebook.com/profile.php?id=100068847397700&mibextid=ZbWKwL"><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-primary btn-sm-square me-2 rounded-circle" href="https://www.tiktok.com/@khaingparami30?_t=8rchDSrokUM&_r=1"><i class="fab fa-tiktok"></i></a>
                                <a class="btn btn-primary btn-sm-square me-2 rounded-circle" href="https://join.skype.com/invite/x8TCnpT7WkI6"><i class="fab fa-skype"></i></a>
                                <a href="https://t.me/khaingparami" class="btn btn-primary btn-sm-square me-2 rounded-circle"><i class="fab fa-telegram"></i></a>
                                <a href="mailto:khaingparami3011@gmail.com" class="btn btn-primary btn-sm-square me-2 rounded-circle">
                                    <i class="fas fa-envelope"></i>
                                </a>
                                <!-- <a href="#" class="btn btn-primary btn-sm-square rounded-circle"><i class="fab fa-linkedin-in"></i></a> -->
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-2 col-md-6">
                        <div class="footer-item">
                            <h4 class="mb-4">Site Map</h4>
                            <div class="d-flex flex-column align-items-start">
                                <a class="text-body mb-3" href=""><i class="fa fa-check text-primary me-2"></i>Home</a>
                                <a class="text-body mb-3" href=""><i class="fa fa-check text-primary me-2"></i>About</a>
                                <a class="text-body mb-3" href=""><i class="fa fa-check text-primary me-2"></i>Courses</a>
                                <a class="text-body mb-3" href=""><i class="fa fa-check text-primary me-2"></i>Activities</a>
                                <a class="text-body mb-3" href=""><i class="fa fa-check text-primary me-2"></i>Blog</a>
                                <a class="text-body mb-3" href=""><i class="fa fa-check text-primary me-2"></i>Contact</a>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-lg-6 col-md-6">
                        <div class="footer-item">
                            <h4 class="mb-4">{{ $t('contact') }}</h4>
                            
                            <div class="d-flex flex-column align-items-start">
                                <p><i class="fa fa-map-marker-alt text-primary me-2"></i> No.125,Tagaung 8th street,5 ward , South Okkalapa Township, Yangon, Myanmar</p>
                                <p><i class="fa fa-phone-alt text-primary me-2"></i> +95 9 44022 8711, 09404437173</p>
                                <p><i class="fas fa-envelope text-primary me-2"></i> kaimyanmar2018@gmail.com</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        
                    </div>
                </div>
            </div>
        </div>
        <!-- Copyright Start -->
        <div class="container-fluid copyright bg-dark py-4">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                        <span class="text-light"><a href="#"><i class="fas fa-copyright text-light me-2"></i>khaingparami.com</a>, All right reserved.</span>
                    </div>
                    <div class="col-md-6 my-auto text-center text-md-end text-white">
                       
                    </div>
                </div>
            </div>
        </div>
        <!-- Copyright End -->


        <!-- Back to Top -->
        <a href="#" class="btn btn-md-square btn-primary rounded-circle back-to-top"><i class="fa fa-arrow-up"></i></a> 
  </div>  
</template>

<script>
export default {

}
</script>

<style>

</style>